import { urlPatterns } from '@pm2/sitemap-utils';
import { parseChildren, allHtmlParsers } from '@utils/ast';
import { configRefs } from '@utils/constants';

const parseInternalLink = (node, context) => {
  const href = node.getAttribute("url");
  const target = (() => {
    if (node.getAttribute("lightbox") === "true") {
      return "_lightbox";
    }
    if (node.getAttribute("target") === "_blank") {
      return "_blank";
    }
  })();
  return parseLink(node, context, {
    href,
    target
  });
};
const parseExternalLink = (node, context) => {
  const href = node.getAttribute("url");
  return parseLink(node, context, {
    href,
    target: "_blank"
  });
};
const parseElementLink = (node, context) => {
  const elementId = node.getAttribute("id");
  const target = (() => {
    if (node.getAttribute("lightbox") === "true") {
      return "_lightbox";
    }
    if (node.getAttribute("target") === "_blank") {
      return "_blank";
    }
  })();
  return parseLink(node, context, {
    href: elementId ? urlPatterns.element(elementId) : void 0,
    target
  });
};
const parseDocumentLink = (node, context) => {
  const href = node.getAttribute("file");
  return parseLink(node, context, {
    href,
    target: "_blank",
    attributes: {
      download: "true"
    }
  });
};
const parseDownloadLink = (node, context) => {
  const href = node.getAttribute("url");
  return parseLink(node, context, {
    href: href ? `${configRefs.apis.pm2.media.dangerouslyAssertSyncValue()}${href}` : void 0,
    target: "_blank",
    attributes: {
      download: "true"
    }
  });
};
const parseAnchor = (node, context) => {
  const attributeEntities = Array.from(node.attributes).map((it) => [it.nodeName, it.nodeValue]).filter((it) => it[1] !== null);
  const attributes = attributeEntities.length > 0 ? Object.fromEntries(attributeEntities) : void 0;
  const href = (() => {
    const rawHref = node.getAttribute("href");
    if (node.getAttribute("data-element-type") === "ResourceLink") {
      return rawHref ? urlPatterns.resource(rawHref) : null;
    } else {
      return rawHref;
    }
  })();
  const target = (() => {
    if (node.getAttribute("lightbox") === "true" || node.getAttribute("data-lightbox") === "true") {
      return "_lightbox";
    }
    if (node.getAttribute("target") === "_blank") {
      return "_blank";
    }
  })();
  return parseLink(node, context, {
    href,
    target,
    attributes
  });
};
function parseLink(node, context, props) {
  const className = node.getAttribute("class");
  const children = parseChildren(node, allHtmlParsers, context.depth + 1);
  if (!props.href) {
    return {
      nodeType: "html",
      tagName: "span",
      attributes: {
        "data-anchor": "invalid href"
      },
      children
    };
  }
  const theme = (className == null ? void 0 : className.includes("button-1")) ? "primary" : (className == null ? void 0 : className.includes("button-2")) ? "secondary" : void 0;
  return {
    nodeType: "text-component.anchor",
    meta: {
      theme,
      target: props.target
    },
    href: props.href,
    attributes: props.attributes,
    children
  };
}
const textComponentLinkParsers = {
  a: parseAnchor,
  document: parseDocumentLink,
  downloadlink: parseDownloadLink,
  elementlink: parseElementLink,
  externallink: parseExternalLink,
  internallink: parseInternalLink
};

export { textComponentLinkParsers };
//# sourceMappingURL=component.text.links.js.map
